<template>
  <div>
    <vx-card id="customTableInboundDetailsDataContainer" :title="$t('custom_table_inbound_details')" class="mb-8 vs-con-loading__container">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-checkbox v-model="formData.selectAll" class="mb-4" @change="selectAllOptions">
            <span v-text="$t('select_all')" />
          </vs-checkbox>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full" :key="key" v-for="(tr, key) in options">
          <vs-checkbox :vs-value="tr.column" v-model="formData.selected" class="mb-4" @change="selectOption">
            <span v-text="$t(tr.label)" v-if="tr.translate === true" />
            <span v-text="tr.label" v-else/>
          </vs-checkbox>
        </div>
      </div>
      <template slot="footer">
        <vs-button color="success" type="filled" size="medium" class="mr-2" @click="update">{{ $t('save') }}</vs-button>
        <vs-button color="primary" type="filled" size="medium" class="mr-2" @click="selectDefaultOptions">{{ $t('select_default') }}</vs-button>
      </template>
    </vx-card>
  </div>
</template>

<script>
import CustomTable from '@/models/CustomTable'

export default {
  name: 'User.Configuration.CustomTable.InboundDetails',
  data () {
    return {
      options: [],
      selectAll: [],
      selectDefault: [],
      lastSelected: '',
      formData: {
        selected: [],
        selectAll: false
      },
      formErrors: {}
    }
  },
  mounted () {
    this.loadMemberCustomTable()
  },
  methods: {
    async loadMemberCustomTable () {
      this.$vs.loading({container: '#customTableInboundDetailsDataContainer'})
      const response = await CustomTable.inboundDetails()
      this.options = response.data.options
      this.selectAll = response.data.select.all
      this.selectDefault = response.data.select.default
      this.formData.selected = response.data.selected
      this.$vs.loading.close('#customTableInboundDetailsDataContainer > .con-vs-loading')
    },
    async update () {
      this.$vs.loading({container: '#customTableInboundDetailsDataContainer'})
      try {
        await CustomTable.inboundDetailsSave(this.formData)
        this.$swalHelper.success({
          title: this.$t('action_success'),
          confirmButton: this.$t('confirm')
        })
      } catch (e) {
        this.formErrors = e.response.data.errors
      }
      this.$vs.loading.close('#customTableInboundDetailsDataContainer > .con-vs-loading')
    },
    selectOption () {
      this.lastSelected = ''
    },
    selectAllOptions () {
      if (this.formData.selectAll === true) {
        this.lastSelected = this.formData.selected
        this.formData.selected = this.selectAll
      } else if (this.lastSelected !== '') {
        this.formData.selected = this.lastSelected
      }
    },
    selectDefaultOptions () {
      this.formData.selected = this.selectDefault
    }
  }
}
</script>

<style lang="scss">
</style>
